// import React from "react"; 
// import "./Popular.css";
// import Item from "../Item/Item";
// import myPic from "../Assets/hero_image.png";

// // ✅ LOCAL DATA (NO BACKEND)
// const trendingData = [
//   {
//     id: 1,
//     title: "How AI is Changing Software Development",
//     image: require("../Assets/media expert.jpeg"),
//     category: "Media Expert",
//     readTime: "Video Editing, Graphics, Videography & Photography",
//     old_price: "From $50 - $2000 per/hr"
//   },
//   {
//     id: 2,
//     title: "React vs Next.js in 2026",
//     image: require("../Assets/production expert.jpeg"),
//     readTime: "Broadcasting, Live Production, Media Production & Production Directing",
//     old_price: "From $500 - $5000 per/hr",
//     category: "Production Expert",
//   },
//   {
//     id: 3,
//     title: "Top 10 Tech Trends You Must Know",
//     image: require("../Assets/tech expert.jpeg"),
//     category: "Tech Expert",
//     readTime: "Website Development, Mobile App Development, Server Management & Maintainance ",
//     old_price: "From $500 - $5000 per/hr"
//   },
//   {
//     id: 4,
//     title: "Building Scalable Apps in Node.js",
//     image: require("../Assets/content production expert.jpeg"),
//     category: "Content Production Expert",
//     readTime: "Content Development, Social Media Influencing, Social Media Followership Management",
//     old_price: "From $20 -$1000 per/hr"
//   },
//     {
//     id: 5,
//     title: "Building Scalable Apps in Node.js",
//     image: require("../Assets/ai expert.jpeg"),
//     category: "AI Expert",
//     readTime: "Automation by AI & AI intergration",
//     old_price: "From $50 - $2000"
//   },
// ];

// const Popular = () => {
//   return (
//     <div className="popular">

//       {/* TRENDING */}
//       <div className="popular-top">
//         <h1>🔥 Hire Media and Technology Expert</h1>
//         <p>Get Latest insights, tutorials and innovations</p>
//         <hr />

//         <div className="popular-item">
//           {trendingData.map((item) => (
//             <Item
//               key={item.id}
//               title={item.title}
//               image={item.image}
//               category={item.category}
//               readTime={item.readTime}
//               // old_price can stay if needed
//               old_price={item.old_price}
//             />
//           ))}
//         </div>
//       </div>

//       {/* HIRE SECTION */}
//       {/* <div className="hire-section">
//         <div className="hire-left">
//           <img src={myPic} alt="expert" />
//         </div>

//         <div className="hire-right">
//           <h2>Hire a Media & Tech Expert</h2>
//           <p>
//             I help brands build powerful tech products, websites, and media solutions.
//           </p>

//           <button className="hire-btn">Hire Me</button>
//         </div>
//       </div> */}

//       {/* PAYMENT SECTION */}
//       <div className="payment-section">
//         <h2>💼 Start a Project</h2>
//         <p>Secure payments. Fast delivery. Trusted service.</p>

//         <div className="payment-buttons">
//           <button>Pay with Card</button>
//           <button>Bank Transfer</button>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default Popular;


// import React from "react";
// import "./Popular.css";
// import Item from "../Item/Item";
// import { useNavigate } from "react-router-dom";
// const trendingData = [
//   {
//     id: 1,
//     title: "How AI is Changing Software Development",
//     image: require("../Assets/media expert.jpeg"),
//     category: "Media Expert",
//     readTime: "Video Editing, Graphics, Videography & Photography",
//     old_price: "From $50 - $2000 per/hr",
//     price: 1000 // ✅ in Naira (₦50,000)
//   },
//   {
//     id: 2,
//     title: "React vs Next.js in 2026",
//     image: require("../Assets/production expert.jpeg"),
//     readTime: "Broadcasting, Live Production, Media Production & Production Directing",
//     old_price: "From $500 - $5000 per/hr",
//     category: "Production Expert",
//     price: 2000
//   },
//   {
//     id: 3,
//     title: "Top 10 Tech Trends You Must Know",
//     image: require("../Assets/tech expert.jpeg"),
//     category: "Tech Expert",
//     readTime: "Website Development, Mobile App Development",
//     old_price: "From $500 - $5000 per/hr",
//     price: 1000
//   },
//   {
//     id: 4,
//     title: "Building Scalable Apps in Node.js",
//     image: require("../Assets/content production expert.jpeg"),
//     category: "Content Production Expert",
//     readTime: "Content Development, Social Media Influencing",
//     old_price: "From $20 -$1000 per/hr",
//     price: 2000
//   },
//   {
//     id: 5,
//     title: "AI Expert",
//     image: require("../Assets/ai expert.jpeg"),
//     category: "AI Expert",
//     readTime: "Automation by AI & AI integration",
//     old_price: "From $50 - $2000",
//     price: 3000
//   },
// ];
// const Popular = () => {
//   const navigate = useNavigate();

//   // 🔥 handle payment
//   const handlePayment = (item) => {
//     navigate("/pay", { state: item }); // send selected service
//   };

//   return (
//     <div className="popular">

//       {/* TRENDING */}
//       <div className="popular-top">
//         <h1>🔥 Hire Media and Technology Expert</h1>
//         <p>Get Latest insights, tutorials and innovations</p>
//         <hr />

//         <div className="popular-item">
//           {trendingData.map((item) => (
//             <div key={item.id} className="popular-card">

//               <Item
//                 title={item.title}
//                 image={item.image}
//                 category={item.category}
//                 readTime={item.readTime}
//                 old_price={item.old_price}
//               />

//               {/* 🔥 PAYMENT BUTTON INSIDE EACH CARD */}
//               <button
//                 className="pay-btn"
//                 onClick={() => handlePayment(item)}
//               >
//                 Pay ${item.price.toLocaleString()}
//               </button>

//             </div>
//           ))}
//         </div>
//       </div>

//       {/* GLOBAL PAYMENT (optional fallback) */}
//       <div className="payment-section">
//         <h2>💼 Start a Project</h2>
//         <p>Select a service above to proceed with payment</p>
//       </div>

//     </div>
//   );
// };

// export default Popular;



import React from "react";
import "./Popular.css";
import Item from "../Item/Item";
import { useNavigate } from "react-router-dom";

const trendingData = [
  {
    id: 1,
    title: "How AI is Changing Software Development",
    image: require("../Assets/media expert.jpeg"),
    category: "Media Expert",
    readTime: "Video Editing, Graphics, Videography & Photography",
    old_price: "From $50 - $2000 per/hr",
    price: 1000,
    Nprice: "1,360,000",
  },
  {
    id: 2,
    title: "React vs Next.js in 2026",
    image: require("../Assets/production expert.jpeg"),
    category: "Production Expert",
    readTime: "Broadcasting, Live Production, Media Production & Production Directing",
    old_price: "From $500 - $5000 per/hr",
    price: 2000,
    Nprice: "2,720,000",
  },
  {
    id: 3,
    title: "Top 10 Tech Trends You Must Know",
    image: require("../Assets/tech expert.jpeg"),
    category: "Tech Expert",
    readTime: "Website Development, Mobile App Development",
    old_price: "From $500 - $5000 per/hr",
    price: 1000,
    Nprice: "1,360,000",
  },
  {
    id: 4,
    title: "Building Scalable Apps in Node.js",
    image: require("../Assets/content production expert.jpeg"),
    category: "Content Production Expert",
    readTime: "Content Development, Social Media Influencing",
    old_price: "From $20 - $1000 per/hr",
    price: 2000,
    Nprice: "2,720,000",
  },
  {
    id: 5,
    title: "AI Expert Consultation",
    image: require("../Assets/ai expert.jpeg"),
    category: "AI Expert",
    readTime: "Automation by AI & AI Integration",
    old_price: "From $50 - $2000 per/hr",
    price: 2000,
    Nprice: "2,720,000",
  },
];

const Popular = () => {
  const navigate = useNavigate();

  const handlePayment = (item) => {
    navigate("/pay", { state: item });
  };

  return (
    <div className="popular">
      <div className="popular-hero">
        <div className="hero-content">
          <div className="badge">🔥 Trending Now</div>
          <h1>Hire Top Media & Technology Experts</h1>
        </div>
      </div>

      <div className="popular-grid">
        {trendingData.map((item) => (
          <div key={item.id} className="popular-card">
            <Item
              title={item.title}
              image={item.image}
              category={item.category}
              readTime={item.readTime}
              old_price={item.old_price}
            />

            <div className="card-footer">
<div className="price-wrapper">
  <span className="price-label">Starting at</span>

  <div className="price-group">
    <span className="price">
      ${item.price.toLocaleString()}
    </span>

    <span className="naira-price">
      ₦{item.Nprice.toLocaleString()}
    </span>
  </div>
</div>

              <button
                className="pay-btn"
                onClick={() => handlePayment(item)}
              >
                Hire Now
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Call-to-action banner */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>Ready to Start Your Project?</h2>
          <p>Browse more experts or tell us what you need — our team will match you instantly.</p>
          <button className="cta-btn">Explore All Experts</button>
        </div>
      </div>
    </div>
  );
};

export default Popular;